module.exports = __webpack_public_path__ + "static/media/bag.4b8a347f.svg";